import api, { normalize } from './api';

/**
 * Consulta CNPJ via backend (proxy ReceitaWS / CNPJ WS) — padrão OSApp.
 * @returns {Promise<{status:string, nome?:string, fantasia?:string, ...}|null>}
 */
export async function consultarCnpj(cnpjCpfFormatado) {
  const cnpj = String(cnpjCpfFormatado || '').replace(/\D/g, '');
  if (cnpj.length !== 14) {
    const err = new Error('CNPJ deve ter 14 dígitos.');
    err.code = 'INVALID_CNPJ';
    throw err;
  }

  const { data } = await api.get('/cnpj/consultar', { params: { cnpj } });
  return normalize(data);
}

/** Campos de endereço/contato/fiscal retornados pela consulta (BrasilAPI / ReceitaWS). */
export function camposDaConsultaCnpj(empresa) {
  if (!empresa || empresa.status !== 'OK') return null;
  const cep = empresa.cep ? String(empresa.cep).replace(/\D/g, '') : '';
  const campos = {
    razaosocial: empresa.nome || '',
    fantasia: empresa.fantasia || '',
    logradouro: empresa.logradouro || '',
    numero: empresa.numero || '',
    complemento: empresa.complemento || '',
    bairro: empresa.bairro || '',
    cidade: empresa.municipio || '',
    uf: empresa.uf || '',
    cep,
    email: empresa.email || '',
    telefone: empresa.telefone || '',
    cnaePrincipal: empresa.cnaePrincipal || '',
    cnaesSecundariosJson: Array.isArray(empresa.cnaesSecundarios)
      ? JSON.stringify(empresa.cnaesSecundarios)
      : empresa.cnaesSecundariosJson || '',
  };
  // Regime / Simples (quando a RFB informa)
  if (empresa.regimeTributario) campos.regimeTributario = empresa.regimeTributario;
  if (typeof empresa.optanteSimples === 'boolean') campos.optanteSimples = empresa.optanteSimples;
  else if (empresa.optanteMei === true) campos.optanteSimples = true;
  return campos;
}

/** Texto curto para toast (ex.: "Simples Nacional ME/EPP"). */
export function resumoRegimeConsultaCnpj(empresa) {
  if (!empresa || empresa.status !== 'OK') return null;
  if (empresa.opSimpNac === '2' || empresa.optanteMei === true || empresa.regimeTributario === 'MEI')
    return 'MEI (opSimpNac=2)';
  if (empresa.opSimpNac === '3' || empresa.optanteSimples === true || empresa.regimeTributario === 'SimplesNacional')
    return 'Simples Nacional ME/EPP (opSimpNac=3)';
  if (empresa.opSimpNac === '1' || empresa.optanteSimples === false)
    return 'Não optante Simples (opSimpNac=1)';
  return null;
}

